module.exports = __webpack_public_path__ + "static/media/wallet@3x.f94d56f2.png";